import makeStyles from '@mui/styles/makeStyles';
import {MessageCircle} from "lucide-react";
import {get} from "lodash";
import React from "react";
import {useTranslation} from "react-i18next";
import {color, font, type} from "common/tokens";
import Avatar from "./Avatar";
import Card from "./Card";
import Chip from "./Chip";
import CtaButton from "./CtaButton";

const useStyles = makeStyles({
  card: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  heading: {
    ...type.cardHeading,
    color: color.TEXT,
    margin: 0,
  },
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    borderTop: `1px solid ${color.DIVIDER}`,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 0',
    borderBottom: `1px solid ${color.DIVIDER}`,
  },
  name: {
    ...type.body,
    fontWeight: font.MEDIUM,
    color: color.TEXT,
    margin: 0,
  },
});

const fullName = member =>
  `${get(member, 'firstName', '')} ${get(member, 'lastName', '')}`.trim();

const RosterCard = ({members = [], onMessageGroup}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  if (!members.length) {
    return null;
  }

  return (
    <Card className={classes.card}>
      <h3 className={classes.heading}>{t('yourGroup')}</h3>

      <ul className={classes.list}>
        {members.map(member => {
          const name = fullName(member);
          return (
            <li className={classes.row} key={get(member, 'id')}>
              <Avatar variant={'roster'} name={name} image={get(member, 'picture')}/>
              <p className={classes.name}>{name}</p>
              {Boolean(get(member, 'role')) && (
                <Chip variant={'role'}>{get(member, 'role')}</Chip>
              )}
            </li>
          );
        })}
      </ul>

      {onMessageGroup && (
        <CtaButton
          fullWidth
          size={'control'}
          variant={'secondary'}
          onClick={onMessageGroup}
          icon={<MessageCircle size={15} strokeWidth={2}/>}
          label={t('messageGroup')}
        />
      )}
    </Card>
  );
};

export default RosterCard;
